/**
 * Catálogo de escopos: liga um template a uma funcionalidade da plataforma.
 *
 * Em arquivo próprio (e não dentro da tela de templates) porque a tela de
 * Setores também precisa dele — é o que permite avisar, ao trocar um setor para
 * a API oficial, QUAIS notificações vão parar por falta de template aprovado.
 */
export interface TemplateUsageScope {
    value: string
    label: string
    variables: string[]
}

export const TEMPLATE_USAGE_SCOPES: TemplateUsageScope[] = [
    {
        value: 'BILLING_APPOINTMENT_CONFIRMATION',
        label: 'Confirmação de agendamento (cliente)',
        variables: ['Local', 'Endereço', 'Data e hora', 'Observações', 'Empresa'],
    },
    {
        value: 'PARTNER_SCHEDULE_NOTIFICATION',
        label: 'Notificação de novo agendamento ao parceiro',
        variables: [
            'Empresa',
            'Paciente',
            'CPF',
            'Serviço solicitado',
            'URL do portal',
            'Código de acesso',
            'Empresa',
        ],
    },
    {
        value: 'AGENDA_REMINDER_CLIENT',
        label: 'Lembrete de agenda (cliente)',
        variables: ['Local', 'Endereço', 'Data e hora', 'Observações', 'Empresa'],
    },
    {
        value: 'AGENDA_EVENT_REMINDER_CLIENT',
        label: 'Lembrete de evento da agenda (cliente)',
        variables: ['Cliente', 'Evento', 'Data e hora', 'Empresa'],
    },
    {
        value: 'AGENDA_REMINDER_PROFESSIONAL',
        label: 'Lembrete de agenda (profissional)',
        variables: ['Profissional', 'Cliente/Título', 'Data e hora', 'Observações'],
    },
    {
        value: 'ORDER_REMINDER',
        label: 'Lembrete de pedido',
        variables: ['Cliente', 'ID do pedido', 'Data e hora', 'Empresa'],
    },
    {
        value: 'ORDER_STATUS_UPDATE',
        label: 'Atualização de status do pedido',
        variables: ['Status', 'ID do pedido'],
    },
    {
        value: 'ORDER_TIME_UPDATE',
        label: 'Atualização de tempo estimado do pedido',
        variables: ['Tempo estimado', 'ID do pedido'],
    },
    {
        value: 'CONSENT_REQUEST',
        label: 'Solicitação de consentimento / assinatura',
        variables: ['Cliente', 'URL de assinatura'],
    },
    {
        value: 'PARTNER_AVAILABILITY_INQUIRY',
        label: 'Consulta de disponibilidade ao parceiro',
        variables: ['Empresa', 'Serviço', 'ID do atendimento'],
    },
    {
        value: 'BILLING_PAYMENT_LINK',
        label: 'Link de pagamento (PIX e cartão) da cobrança',
        variables: ['Cliente', 'Empresa', 'Valor', 'Vencimento', 'Link de pagamento'],
    },
    {
        value: 'PROCEDURE_FLEX_LINK',
        label: 'Link flex — acompanhamento/pagamento do procedimento',
        variables: ['Cliente', 'Empresa', 'Valor total', 'Link de acompanhamento'],
    },
]
